module.exports = __webpack_public_path__ + "img/fixed.94eab002.png";